import { TransportZoneService } from 'src/app/angularJS/services/transport-zone/transport-zone.service';
import { UserService } from 'src/app/angularJS/services/user/user.service';
import { QueryBuilder } from 'src/app/angularJS/services/query-builder.service';
import { LinkBuilder } from 'src/app/angularJS/services/link-builder.service';

export const initialise = () => {
  const getTransportZones = (transportZoneService: TransportZoneService, userService: UserService, queryBuilder: QueryBuilder, linkBuilder: LinkBuilder, $q: ng.IQService) => {
    if (!userService.selectedSchemes || userService.selectedSchemes.length === 0) {
      const deferred = $q.defer();
      const callbackRef = userService.registerSchemeCallback(() => {
        userService.unregisterCallback(callbackRef);
        const schemeLinks = userService.selectedSchemes.map((selectedScheme) => {
          return linkBuilder.getSchemesLink(selectedScheme.id);
        });

        const query = queryBuilder.newParam().fieldIn('scheme.link', schemeLinks).getParam();
        transportZoneService.getList(1, 15, query).then((response) => {
          deferred.resolve(response);
        });
      });

      return deferred.promise;
    } else {
      const schemeLinks = userService.selectedSchemes.map((selectedScheme) => {
        return linkBuilder.getSchemesLink(selectedScheme.id);
      });
      const query = queryBuilder.newParam().fieldIn('scheme.link', schemeLinks).getParam();
      return transportZoneService.getList(1, 15, query);
    }
  };
  getTransportZones.$inject = ['transportZoneService', 'userService', 'QueryBuilder', 'LinkBuilder', '$q'];

  const getTransportZone = (transportZoneService: TransportZoneService, $state: ng.ui.IStateService, $stateParams: ng.ui.IStateParamsService, $q: ng.IQService, $timeout: ng.ITimeoutService) => {
    if ($stateParams.zoneId) {
      return transportZoneService.get($stateParams.zoneId);
    }

    if (!$stateParams.importedTransportZone) {
      setTimeout(() => {
        $state.go('transport-zones');
      }, 200);

      return $q.reject();
    }
  };
  getTransportZone.$inject = ['transportZoneService', '$state', '$stateParams', '$q', '$timeout'];

  angular.module('app.transport-zones').config(['$stateProvider', '$urlRouterProvider', '$locationProvider', ($stateProvider, $urlRouterProvider, $locationProvider) => {
    $locationProvider.hashPrefix('');
    $stateProvider.state('transport-zones', {
      url: '/transport-zones',
      templateUrl: 'app/angularJS/features/transport-locations/zones/transport-zones.html',
      controller: 'transportZonesController',
      controllerAs: 'vm',
      parent: 'common',
      resolve: {
        transportZonesResponse: getTransportZones
      }
    }).state('transport-zone-edit', {
      url: '/transport-zone-edit/:zoneId',
      templateUrl: 'app/angularJS/features/transport-locations/zones/edit/transport-zone-edit.html',
      controller: 'transportZoneEditController',
      controllerAs: 'vm',
      parent: 'common',
      params: {
        zoneId: '',
        importedTransportZone: ''
      },
      resolve: {
        getTransportZoneResponse: getTransportZone
      }
    });
    $urlRouterProvider.otherwise('/');
  }]);
};